import React from 'react';
import MonacoEditor from '@monaco-editor/react';
import { javascript } from '@codemirror/lang-javascript';
import { useTheme } from '../../contexts/ThemeContext';
import './CodeEditor.css';

const CodeEditor = ({
  code,
  onChange,
  readOnly = false,
  placeholder = "Write your code here...",
  language = "javascript"
}) => {
  const { isLight } = useTheme();
  const handleChange = React.useCallback((value) => {
    onChange && onChange(value);
  }, [onChange]);

  return (
    <div className="code-editor">
      <MonacoEditor
        width="100%"
        height="200px"
        defaultLanguage={language}
        language={language}
        value={code}
        theme={isLight ? 'vs' : 'vs-dark'}
        options={{
          readOnly: readOnly,
          minimap: { enabled: false },
          fontSize: 16,
          lineNumbers: "on",
          wordWrap: "on",
          roundedSelection: true,
          scrollbar: { vertical: "auto", horizontal: "auto" },
          renderLineHighlight: "all",
          overviewRulerLanes: 0,
          renderIndentGuides: false,
          folding: false,
          contextmenu: false,
          renderLineHighlightOnlyWhenFocus: true,
        }}
        placeholder={placeholder}
        onChange={handleChange}
        className="studymode-monaco-editor"
      />
    </div>
  );
};

export default CodeEditor;
